module.exports = __webpack_public_path__ + "img/steam-circle.cbcd54d.svg";